import React, { useState } from 'react';
import { db } from '../firebase'; // Firestore bağlantısı için firebase dosyanızdan içe aktarım yapın
import { collection, addDoc } from 'firebase/firestore'; // Firestore metodları
import './adminilanekle.css';

const   Ilanlar = () => {
  const [positionName, setPositionName] = useState('');
  const [employmentType, setEmploymentType] = useState('');
  const [location, setLocation] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [qualifications, setQualifications] = useState(['']); // Başlangıçta bir nitelik alanı
  const mode= "active";

  const handleQualificationChange = (index, event) => {
    const newQualifications = [...qualifications];
    newQualifications[index] = event.target.value;
    setQualifications(newQualifications);
  };

  const handleAddQualification = () => {
    setQualifications([...qualifications, '']);
  };

  const handleRemoveQualification = (index) => {
    const newQualifications = qualifications.filter((_, i) => i !== index);
    setQualifications(newQualifications);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await addDoc(collection(db, 'jobPostings'), {
        positionName,
        employmentType,
        location,
        jobDescription,
        qualifications,
        mode
      });
      // Formu temizle
      setPositionName('');
      setEmploymentType('');
      setLocation('');
      setJobDescription('');
      setQualifications(['']);
    } catch (error) {
      console.error('İş ilanı eklenirken hata oluştu:', error);
    }
  };

  return (
    <div className="admin-panel-container">
      <h2 className="title">Yeni İş İlanı Ekle</h2>
      <form onSubmit={handleSubmit} className="job-form">
        <label>
          Pozisyon İsmi:
          <input type="text" value={positionName} onChange={(e) => setPositionName(e.target.value)} required />
        </label>
        <label>
          Çalışma Şekli:
          <select value={employmentType} onChange={(e) => setEmploymentType(e.target.value)} required>
            <option value="">Seçin</option>
            <option value="Tam Zamanlı">Tam Zamanlı</option>
            <option value="Yarı Zamanlı">Yarı Zamanlı</option>
          </select>
        </label>
        <label>
          Konum:
          <select value={location} onChange={(e) => setLocation(e.target.value)} required>
            <option value="">Seçin</option>
            <option value="Samsun">Samsun</option>
            <option value="İstanbul">İstanbul</option>
          </select>
        </label>
        <label>
          İlan Metni:
          <textarea value={jobDescription} onChange={(e) => setJobDescription(e.target.value)} required></textarea>
        </label>
        <label>
          Genel Nitelikler:
          {qualifications.map((qualification, index) => (
            <div key={index} className="qualification-group">
              <input
                type="text"
                value={qualification}
                onChange={(event) => handleQualificationChange(index, event)}
                placeholder={`Nitelik ${index + 1}`}
              />
              <button type="button" onClick={() => handleRemoveQualification(index)}>Sil</button>
            </div>
          ))}
          <button type="button" onClick={handleAddQualification}>Nitelik Ekle</button>
        </label>
        <button type="submit" className="submit-button">Kaydet</button>
      </form>
    </div>
  );
};

export default Ilanlar;
